<template>
    <span class="chevron-outline-icon">
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="stroke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path :d="path" />
        </svg>
    </span>
</template>

<script>
const PATHS = {
    up: 'm18 15-6-6-6 6',
    down: 'm6 9 6 6 6-6',
    left: 'm15 18-6-6 6-6',
    right: 'm9 18 6-6-6-6',
};

export default {
    name: 'IconChevronOutline',
    props: {
        direction: {
            type: String,
            default: 'down',
            validator: (value) => Object.keys(PATHS).includes(value),
        },
        stroke: {
            type: String,
            default: 'currentColor',
        },
    },
    computed: {
        path() {
            return PATHS[this.direction];
        },
    },
};
</script>

<style scoped>
/* See IconPlayOutline.vue for why the wrapper needs to be a flex container
   itself: a plain <span> as a flex/grid item doesn't center its own
   inline-level svg content vertically. */
.chevron-outline-icon {
    display: inline-flex;
    align-items: center;
}
</style>
